<template>
  <div>
    <Form
      page-title="Edit Service"
      buttonName="Update"
      :isInList="isInList"
      :model="model"
      @showAddChanged="$emit('showAddChanged', $event)"
      @submit="submit"
      :loading="loading"
    />
  </div>
</template>
<script>
import { submitAndNotify } from "@/helpers/utils";
import Form from "./Form";
import { updateService } from "@/API/ServicesAPIs";
export default {
  name: "Edit",
  components: { Form },
  props: ["isInList", "model", "showAdd"],
  data() {
    return {
      loading: false
    };
  },
  methods: {
    submit(formData) {
      const callback = () => {
        this.$emit("onSubmit");
        this.$emit("showAddChanged", !this.showAdd);
      };
      submitAndNotify(this, updateService(formData), callback);
    }
  }
};
</script>
<style></style>
